// extracted by mini-css-extract-plugin
export default {"link":"LeftWorkCard_link__w5fvP","content":"LeftWorkCard_content__Hekvm"};